// import React, { useEffect, useState } from "react";
// import { baseUrl } from "../../config/baseUrl";
// import axios from "axios";
// import { Link, NavLink } from "react-router-dom";
// import { format } from "date-fns";
// import EduPagination from "../edu-pagination/edu-pagination";
// import ArchiveModal from "../edu-helper/archive-modal";

// export const EduCompanyListTable = ({
//   userType,
//   archivedVal,
//   setUserData,
//   setShowList,
//   forceUpdate,
//   setForceUpdate,
//   activateEduCompanyEdit,
//   setActivateEduCompanyEdit,
//   setCompanyData,
// }) => {
//   const [companyList, setCompanyList] = useState([]);
//   const [pageNumber, setPageNumber] = useState(1);
//   const [pageLimit, setPageLimit] = useState(10);
//   const [totalCount, setTotalCount] = useState(0);
//   const [archiveid, setArchiveid] = useState();

//   const getCompanyList = async () => {
//     try {
//       let response = await axios(
//         `${baseUrl}/get_company/?per_page=${pageLimit}&page=${pageNumber}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: "Token " + localStorage.getItem("token"),
//           },
//         }

//       );
//       if (response?.status === 200) {
//         if (Boolean(response?.data?.data)) {

//           setTotalCount(response?.data?.data?.length || 0);
//           setCompanyList(response?.data?.data || []);
//           //   setCompanyData(response?.data?.data || []);
//         } else {
//           setCompanyList([]);
//         }
//       }
//     } catch (error) {
//       setCompanyList([]);
//     }
//   };

//   const archiveCompany = async (companyId) => {
//     try {
//       let response = await axios(`${baseUrl}/archive_restore_api/${companyId}/`, {
//         method: "PATCH",
//         headers: {
//           Authorization: "Token " + localStorage.getItem("token"),
//         },
//         data: { archived: !currentArchivedStatus },
//       });
//       if (response?.status === 200) {
//         setForceUpdate(!forceUpdate);
//       }
//     } catch (error) {}
//   };

//   useEffect(() => {
//     (async function () {
//       await getCompanyList();
//     })();
//   }, [forceUpdate]);

//   return (
//     <div className="cards user-list">
//       <div className="row">
//         <div className="col-lg-12">
//           <div className="table table-responsive custom-table management-table">
//             <table className="table table-borderless">
//               <thead>
//                 <tr>
//                   <th>Sr No.</th>
//                   <th>Company Name </th>
//                   <th>Description</th>
//                   <th>Created at</th>
//                   {userType === "SUPER_ADMIN" && <th>Action</th>}
//                 </tr>
//               </thead>
//               <tbody>
//                 {companyList?.length > 0 ? (
//                   <>
//                     {companyList?.map((ul, idx) => {
//                       return (
//                         <tr key={ul?.id}>
//                           <td>{++idx + 10 * (pageNumber - 1)}</td>
//                           <td style={{ textTransform: "capitalize" }}>
//                             {ul?.name}
//                           </td>
//                           <td>{ul?.description}</td>
//                           <td>{format(ul?.created_at, "MMM dd, y")}</td>
//                           <td>
//                             <div className="d-flex flex-row">
//                               <Link
//                                 role="button"
//                                 className="btn btn-outline-warning ms-2 btn-sm"
//                                 data-bs-toggle="modal"
//                                 data-bs-target="#archivemodal"
//                                 onClick={() => {
//                                   setArchiveid(ul?.id);
//                                 }}
//                               >
//                                 <i className="fa fa-cloud-upload " />
//                               </Link>
//                               <Link
//                                 role="button"
//                                 className="btn btn-outline-warning ms-2 btn-sm"
//                                 data-bs-toggle="modal"
//                                 data-bs-target="#edit-company"
//                                 onClick={(e) => {
//                                   setCompanyData(ul);
//                                   setActivateEduCompanyEdit(true);
//                                 }}
//                               >
//                                 <i className="fa fa-edit " />
//                               </Link>
//                             </div>
//                           </td>
//                           {/* {userType === "ADMIN_MANAGER" ? (
//                             <td>
//                               <div className="d-flex flex-row">
//                                 <Link
//                                   role="button"
//                                   className="btn btn-outline-warning ms-2 btn-sm"
//                                   data-bs-toggle="modal"
//                                   data-bs-target="#archivemodal"
//                                   onClick={() => {
//                                     setArchiveid(ul?.id);
//                                   }}
//                                 >
//                                   <i className="fa fa-cloud-upload " />
//                                 </Link>
//                                 <Link
//                                   role="button"
//                                   className="btn btn-outline-warning ms-2 btn-sm"
//                                   data-bs-toggle="modal"
//                                   data-bs-target="#edit-user"
//                                   onClick={(e) => {
//                                     setUserData(ul);
//                                     setActivateEduUserEdit(true);
//                                   }}
//                                 >
//                                   <i className="fa fa-edit " />
//                                 </Link>
//                               </div>
//                             </td>
//                           ) : null}*/}

//                           {/* {archivedVal !== "Restore" && (
//                             <td>
//                               <div className="d-flex flex-row">
//                                 <Link
//                                   className="btn btn-outline-info btn-sm"
//                                   role="button"
//                                   onClick={(e) => {
//                                     setUserData(ul);
//                                     setShowList(false);
//                                   }}
//                                 >
//                                   <i className="fa fa-eye" />
//                                 </Link>
//                               </div>
//                             </td>
//                           )} */}
//                         </tr>
//                       );
//                     })}
//                   </>
//                 ) : (
//                   <table>
//                     <tr>
//                       <td colSpan="4">
//                         <span>No data available</span>
//                       </td>
//                     </tr>
//                   </table>
//                 )}
//               </tbody>
//             </table>
//             <EduPagination
//               pageNumber={pageNumber}
//               setPageNumber={setPageNumber}
//               pageLimit={pageLimit}
//               setPageLimit={setPageLimit}
//               totalCount={totalCount}
//             />
//           </div>
//         </div>
//       </div>
//       <ArchiveModal archiveHandle={archiveCompany} id={archiveid} />
//     </div>
//   );
// };

"use client";

import React, { useEffect, useState } from "react";
import { baseUrl } from "../../config/baseUrl";
import axios from "axios";
import { Link } from "react-router-dom";
import { format, isValid, parseISO } from "date-fns";
import EduPagination from "../edu-pagination/edu-pagination";
import ArchiveModal from "../edu-helper/archive-modal";

// Helper function to safely format dates
const safeFormatDate = (dateString, formatString) => {
  if (!dateString) return "N/A";

  try {
    // Try to parse the date string
    const date = parseISO(dateString);
    if (isValid(date)) {
      return format(date, formatString);
    }
    return "Invalid Date";
  } catch (error) {
    return "Invalid Date";
  }
};

export const EduCompanyListTable = ({
  userType,
  archivedVal,
  setUserData,
  setShowList,
  forceUpdate,
  setForceUpdate,
  activateEduCompanyEdit,
  setActivateEduCompanyEdit,
  setCompanyData,
  setCompanyCount,
}) => {
  const [companyList, setCompanyList] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [hasPreviousPage, setHasPreviousPage] = useState(false);
  const [nextPage, setNextPage] = useState(null);
  const [previousPage, setPreviousPage] = useState(null);
  const [archiveid, setArchiveid] = useState();

  const getCompanyList = async () => {
    try {
      const url =
        userType === "ADMIN_MANAGER"
          ? `${baseUrl}/get_company/?per_page=${pageLimit}&page=${pageNumber}`
          : `${baseUrl}/get_superuser_company/?per_page=${pageLimit}&page=${pageNumber}`;

      let response = await axios(url, {
        method: "GET",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
      });

      if (response?.status === 200) {
        const responseData = response.data;

        // Set pagination data from response
        setTotalCount(responseData.count || 0);
        setHasNextPage(responseData.hasNextPage || false);
        setHasPreviousPage(responseData.previous !== null);
        setNextPage(responseData.next);
        setPreviousPage(responseData.previous);

        // Set company list data
        setCompanyList(responseData.data || []);
        // Update the company count in parent component
        if (setCompanyCount) {
          setCompanyCount(responseData.count || 0);
        }
      } else {
        setCompanyList([]);
        setTotalCount(0);
        setHasNextPage(false);
        setHasPreviousPage(false);
        setNextPage(null);
        setPreviousPage(null);
        if (setCompanyCount) {
          setCompanyCount(0);
        }
      }
    } catch (error) {
      console.error("Error fetching company list:", error);
      setCompanyList([]);
      setTotalCount(0);
      setHasNextPage(false);
      setHasPreviousPage(false);
      setNextPage(null);
      setPreviousPage(null);
      if (setCompanyCount) {
        setCompanyCount(0);
      }
    }
  };

  const archiveCompany = async (companyId) => {
    try {
      // Find the company to get its current archived status
      const company = companyList.find((comp) => comp.id === companyId);
      const currentArchivedStatus = company?.archived || false;

      const response = await axios(
        `${baseUrl}/archive_restore_api/${companyId}/?is_archived=True`,
        {
          method: "PATCH",
          headers: {
            Authorization: "Token " + localStorage.getItem("token"),
          },
        }
      );

      if (response?.status === 200) {
        setForceUpdate(!forceUpdate);
      }
    } catch (error) {
      console.error("Error archiving company:", error);
    }
  };

  useEffect(() => {
    getCompanyList();
  }, [forceUpdate, pageNumber, pageLimit]);

  return (
    <div className="cards user-list">
      <div className="row">
        <div className="col-lg-12">
          <div className="table table-responsive custom-table management-table">
            <table className="table table-borderless">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Company Name</th>
                  <th>Description</th>
                  <th>Created At</th>
                  {userType === "SUPER_ADMIN" && <th>Action</th>}
                </tr>
              </thead>
              <tbody>
                {companyList.length > 0 ? (
                  companyList.map((ul, idx) => (
                    <tr key={ul?.id}>
                      <td>{idx + 1 + pageLimit * (pageNumber - 1)}</td>
                      <td style={{ textTransform: "capitalize" }}>
                        {ul?.name}
                      </td>
                      <td>{ul?.description}</td>
                      <td>{safeFormatDate(ul?.created_at, "MMM dd, yyyy")}</td>
                      {userType === "SUPER_ADMIN" && (
                        <td>
                          <div className="d-flex flex-row">
                            <Link
                              role="button"
                              className="btn btn-outline-warning ms-2 btn-sm"
                              data-bs-toggle="modal"
                              data-bs-target="#archivemodal"
                              onClick={() => setArchiveid(ul?.id)}
                            >
                              <i className="fa fa-cloud-upload" />
                            </Link>
                          </div>
                        </td>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      <span>No data available</span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <EduPagination
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              totalCount={totalCount}
            />
          </div>
        </div>
      </div>

      <ArchiveModal archiveHandle={archiveCompany} id={archiveid} />
    </div>
  );
};
